import { NextEpisode, Progress } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { isWatchingCompleted } from '@/shared/lib/watching';

import { I18n } from '../hooks/useI18n';

interface GetWatchingTextArgs {
    isTvSeries: boolean;
    i18n: I18n;
    progress: Progress | null;
    nextEpisode: NextEpisode | null;
}

export const getWatchingText = ({
    isTvSeries,
    i18n,
    progress,
    nextEpisode,
}: GetWatchingTextArgs): string => {
    if (isTvSeries) {
        if (!nextEpisode?.fallback && nextEpisode?.contentId) {
            return i18n('content_actions__keep_watching_text');
        }

        return i18n('content_actions__play_series_text');
    }

    if (
        progress?.currentTime &&
        !isWatchingCompleted({
            currentTime: progress?.currentTime,
            duration: progress?.duration,
            skippableFragments: undefined,
            toleranceMs: 20000,
        })
    ) {
        return i18n('content_actions__keep_watching_text');
    }

    return i18n('content_actions__play_movie_text');
};
